import { takeEvery, call, fork, put } from 'redux-saga/effects'
import { indicateProgress } from 'api'
import { activateAccount } from 'activation/nAmApi'
import * as constants from 'activation/constants'
import { setAuthFormState } from 'login-and-signup/actions'
import { AUTH_CONTAINER_STATE_ADD_ACCOUNT_DETAILS } from 'login-and-signup/constants'

export function* activateAccountSaga() {
    yield takeEvery(constants.ACTIVATE_ACCOUNT, function* ({ accountKey, validationCode }) {
        try {
            yield indicateProgress(['activateAccount'], function* () {
                yield call(activateAccount, accountKey, validationCode)
                yield put(setAuthFormState(AUTH_CONTAINER_STATE_ADD_ACCOUNT_DETAILS))
            })
        } catch (err) {}
    })
}

export default function* rootSaga() {
    yield fork(activateAccountSaga)
}
